
import ScrollToTop from "./components/Common/ScrollToTop";
import AppRoutes from "./routes/AppRoutes";

function App() {
  return (
    <>
      <ScrollToTop />

      <AppRoutes />
    </>
  );
}

export default App;
